<div class="card-view-primary-box app-scrollbar">
  <div class="header row align-items-center">
    <div class="col-11 d-flex align-items-end">
      <div class="col-12 d-flex align-items-center">
        <ng-container [ngSwitch]="user?.userGroup">
          <ng-container *ngSwitchCase="('SHOWINGS' | translate)">
            <img
              src="assets/svg/ico-home-with-hand-circle.svg"
              alt="home icon"
            />
          </ng-container>
          <ng-container *ngSwitchCase="('MAINTENANCE' | translate)">
            <img
              src="assets/svg/ico-traffic-cone-circle.svg"
              alt="maintenance icon"
            />
          </ng-container>
          <ng-container *ngSwitchCase="('PRIVATE_EVENTS' | translate)">
            <img
              src="assets/svg/icon-glass-circle.svg"
              alt="private event icon"
            />
          </ng-container>
        </ng-container>

        <span class="count pr-10 pl-12">
          {{ user?.totalCount }}
        </span>
        <div class="dashboard-card-header">
          <ng-container [ngSwitch]="user.userGroup">
            <ng-container *ngSwitchCase="('SHOWINGS' | translate)">
              {{ ('SHOWINGS' | translate) }}
            </ng-container>
            <ng-container *ngSwitchCase="('MAINTENANCE' | translate)">
              {{ ('MAINTENANCE' | translate) }}
            </ng-container>

            <ng-container *ngSwitchCase="('PRIVATE_EVENTS' | translate)">
              {{ ('PRIVATE_EVENTS' | translate) }}
            </ng-container>
          </ng-container>
        </div>
      </div>
    </div>
    <div class="col-1 text-center" (click)="addUserHandler(user)">
      <img src="assets/svg/ico-add.svg" class="pointer-cursor" alt="add icon" />
    </div>
    <hr class="col-12 divider" />
  </div>

  <div class="content position-relative">
    <ng-container *ngIf="user?.users?.length > 0">
      <div class="main-containter" *ngFor="let userObj of user?.users">
        <ng-container *ngIf="!userObj?.isExpired">
          <a
            class="user-item"
            [routerLink]="[
              'users',

              encode(user?.userGroup),
              encode(user?.userGroupId),
              encode(userObj.id)
            ]"
          >
            <div class="row py-2 mx-2 item pointer-cursor">
              <div class="col-2">
                <app-profile-picture
                  [name]="userObj?.user"
                  [userData]="userObj"
                >
                </app-profile-picture>
              </div>
              <div class="col-4">
                <div class="col-12 heading3">
                  <div class="col-12 dashboard-list-content">
                    <app-with-tooltip [showHelpCursor]="true">
                      {{ userObj?.user }}
                    </app-with-tooltip>
                  </div>
                </div>
                <div class="col-12 status">
                  <app-with-tooltip [showHelpCursor]="true">
                    {{ userObj?.userType || "" }}
                    {{ userObj?.unitName }}
                    {{ userObj?.buildingName }}</app-with-tooltip
                  >
                </div>
              </div>
              <div
                class="col-6 d-flex px-1 text-right align-self-center justify-content-end d-flex"
              >
              <ng-container *appHideAccess="commonAccessControl">

                <div class="ml-auto col-8" *ngIf="userObj?.startTime !== null">
                  <app-with-tooltip [showHelpCursor]="true">
                    {{
                      userObj?.startTime | parsedDateTime : "yyyy/MM/dd hh:mm a"
                    }}
                    -

                    {{
                      userObj?.expireTime !== null &&
                      userObj?.expireTime !== undefined &&
                      convertNumber(userObj?.expireTime) !== 0
                        ? (userObj.expireTime
                          | parsedDateTime : "yyyy/MM/dd hh:mm a")
                        : ("NO_EXPIRY" | translate)
                    }}
                  </app-with-tooltip>
                </div>
                <div class="time" *ngIf="userObj?.repeatStartTime">
                  {{
                    userObj?.repeatStartTime | parsedTime : "HH:mm" : "hh:mm a"
                  }}
                  <ng-container *ngIf="userObj?.repeatEndTime">-</ng-container>
                  {{
                    userObj?.repeatEndTime | parsedTime : "HH:mm" : "hh:mm a"
                  }}
                  <div class="ml-auto col-5">
                    <app-with-tooltip [showHelpCursor]="true">
                      {{ userObj?.repeatDays | parsedDateTime : 'EEEE' : "EEEE" }}
                    </app-with-tooltip>
                  </div>
                </div>
              </ng-container>
                <div class="align-self-center">
                  <img
                    src="assets/svg/ico-chevron-forward-outline.svg"
                    alt="forward icon"
                  />
                </div>
              </div>
            </div>
          </a>
        </ng-container>
      </div>
    </ng-container>

    <ng-container *ngIf="user?.users?.length === 0">
      <p class="no-record">
        {{ ('RECORD_NOT_FOUND' | translate) }}
      </p>
    </ng-container>
  </div>
  <a
  
    [ngClass]="
      user?.totalCount > dashboardManagementService.maxCardRecords ||
      user?.users?.length > dashboardManagementService.maxCardRecords
        ? 'visible'
        : 'invisible'
    "
    class="view-all-btn d-flex justify-content-center align-items-center pointer-cursor"
  >
  <span [routerLink]="['users', encode(user?.userGroup), encode(user?.userGroupId)]">
    <p class="mt-1 mb-0">{{ ('VIEW_ALL' | translate) }}</p>
  </span>
  </a>
</div>
